
import {createLoadableList} from 'helpers/context'

const rollbook = {
   rollbookRefresh: 0,
   rollbookContextGrades: createLoadableList(),
   rollbookContextGradesToExport: [],
   rollbookContextGradeColumns: createLoadableList(),
   rollbookContextStudentAssignmentProperties: {},
   rollbookContextPeriods: createLoadableList(),
   rollbookContextGradingDialogs: {
     'add-external-grade': false,
     'export-rollbook': false
   },
   rollbookContextStudentGradesNavigation: {
      origin: undefined,
      query: {}
   },
   rollbookContextDeleteGrade: {open: false, grade: undefined}
}

export {rollbook as default} 